import { Dispatch, SetStateAction } from "react";

import { IHubWithStationPairs, StationApi } from "@ryde/shared";

export const loadHubsWithStationPairs = async ({
  isCancelled,
  setHubs,
  setIsLoading,
}: {
  isCancelled: () => boolean;
  setHubs: Dispatch<SetStateAction<IHubWithStationPairs[]>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}): Promise<void> => {
  try {
    const list = await StationApi.getHubsWithStationPairs();
    if (!isCancelled()) {
      setHubs(list);
    }
  } catch {
    if (!isCancelled()) {
      setHubs([]);
    }
  } finally {
    if (!isCancelled()) {
      setIsLoading(false);
    }
  }
};
